import React from 'react';

const CommonSelectField = ({name,onChange,label,require,value,data,error}) => {
    return (
        <div className="form-group col-md-6">
            <label htmlFor="inputEmail233">{label} {require&&<span className="text-danger">*</span>}</label>
            <select id={name}
                    name={name}
                    className="select single-select form-control"
                    onChange={onChange}
                    value={value}
            >
                <option value="">Please Select</option>
                {data && data.map((d, index) => <option key={index}
                                                                    selected={index === 0 ? index === 0 : ''}
                                                                    value={d}>{d}</option>)}
            </select>
            {error && <span className='text-danger'>{error}</span>}
        </div>
    );
};

export default CommonSelectField;